import { html } from '@polymer/polymer/polymer-element';
import { KatapultWidget } from './katapult-widget';
import { snakeCase, capitalCase } from 'change-case';
import * as XLSX from 'xlsx';
import '@polymer/paper-toast/paper-toast.js';
import '../../paper-table/paper-table';
import '../../style-modules/paper-table-style';
import '../../katapult-auth/katapult-auth';
('../katapult-elements/katapult-button.js');

class CompanyWidget extends KatapultWidget {
  // Override widget title template
  static get widgetTitleTemplate() {
    return html`Company Widget`;
  }

  // Override properties
  static get properties() {
    return {
      allData: {
        type: Array,
        value: []
      },
      companyData: {
        type: Array,
        value: []
      }
    };
  }

  // Override body template
  static get bodyTemplate() {
    return html`
      <style include="paper-table-style">
        * {
          font-family: 'Roboto';
        }
        paper-row {
          height: auto;
        }
        .emails .indent {
          border-top: 1px dashed #8eb1bd;
        }
        paper-checkbox {
          --paper-checkbox-unchecked-color: #007299;
        }
        katapult-button {
          border-radius: 20px;
        }
        .indent {
          padding: 5px 10px;
        }
        /* Long email scrollbar formatting */
        ::-webkit-scrollbar {
          height: 3px;
        }
        ::-webkit-scrollbar-thumb {
          background: #d6d6d6;
        }
        ::-webkit-scrollbar-thumb:hover {
          background: #888;
        }
        /* Company title card formatting */
        .company-names {
          background-color: #007299;
          color: white;
          font-weight: bold;
          font-size: 24px;
          padding: 20px;
          border: 1px dotted #007299;
          border-radius: 40px;
        }
        .company-names:hover {
          background-color: #003e51 !important;
          color: white !important;
        }
        /*This table is the information below each company name*/
        .table {
          margin: 5px;
          border-radius: 10px;
          color: #404040;
          font-size: 20px;
          width: 100%;
        }
        /* This is the table of users and their information, within .table */
        .emails {
          color: #404040;
          font-size: 20px;
          padding-top: 5px;
        }
        .emails paper-cell {
          padding: 5px 0 0 0;
        }
        /* Titles within the users (.emails) table*/
        .user-titles {
          padding: 5px 10px;
          font-weight: bold;
          color: #003e51;
        }
        /* Titles for company-broad data */
        .title {
          font-weight: bold;
          color: #003e51;
          padding-right: 10px;
        }
        /* Flex for .table */
        .flex {
          display: flex;
        }
        .days-column {
          flex-grow: 1;
          flex-basis: 100px;
        }
        .subs-column {
          flex-grow: 1;
          flex-basis: 175px;
          padding-left: 10px;
        }
        .creation-column {
          flex-grow: 2;
          flex-basis: 200px;
        }
        /* Flex for .emails */
        .permissions-column {
          flex-grow: 1;
          flex-basis: 30px;
        }
        .active-column {
          flex-grow: 2;
          flex-basis: 115px;
        }
        .users-column {
          flex-grow: 2;
          flex-basis: 325px;
          overflow-x: auto;
          margin-right: 15px;
        }
        .users {
          color: #ff8300;
        }
        .users:hover {
          text-decoration: underline;
        }
        /* Additional Table Formatting */
        .permissions {
          position: relative;
          margin: 0 auto;
        }
        .collapse {
          display: none;
          padding: 0 10px 10px 10px;
          border-radius: 0 0 40px 40px;
          border: 1px dotted #007299;
        }
        .company-data-row {
          padding-left: 0;
        }
        paper-checkbox {
          position: relative;
          margin: 0 auto;
          padding-left: 10px;
        }
        /* Export button and dialogue box formatting */
        #export-button {
          margin: 0 auto;
        }
        #export {
          padding: 0 5px;
          font-size: 20px;
        }
        #check-all,
        .checkbox-cell {
          max-width: fit-content;
        }
        #check-all span,
        .company-export-table {
          font-size: 18px;
        }
        #final-export {
          margin: 0 auto;
          font-size: 18px;
        }
        .company-export-row {
          color: #003e51;
          margin: 5px;
          border: 10px solid #c2c2c2;
          border-radius: 40px;
        }
        .export-instructions {
          padding: 12px;
        }
      </style>

      <paper-toast text="Terms and conditions" duration="3000" id="toast"></paper-toast>

      <div slot="buttons" style="text-align:right gap:10px">
        <!-- Main Table, includes inner individual company tables -->
        <paper-table>
          <template is="dom-repeat" items="{{allData}}">
            <paper-row>
              <!-- This table includes the company name and all associated data -->
              <paper-table id="[[item.name]]" class="table">
                <!-- Always visible row -->
                <paper-row class="company-names" on-click="expandContent"><span>{{item.name}}</span></paper-row>
                <!-- Collapsable Content -->
                <div class="collapse">
                  <!-- Subscribers, Creation Date and Days Left -->
                  <paper-row class="company-data-row">
                    <paper-cell class="subs-column flex">
                      <span class="title">Subscribers</span>
                      <span>{{item.used_write_license}} / {{item.subscription}}</span>
                    </paper-cell>
                    <paper-cell class="creation-column flex">
                      <span class="title">Creation Date</span>
                      <span>{{item.creation_date}}</span>
                    </paper-cell>
                    <paper-cell class="days-column flex">
                      <span class="title">Days Left</span>
                      <span>{{item.days_left}}</span>
                    </paper-cell>
                  </paper-row>
                  <!-- Emails and Last Active Table-->
                  <paper-table class="emails">
                    <paper-row class="user-titles">
                      <paper-cell class="users-column flex">Users</paper-cell>
                      <paper-cell class="active-column flex">Last Active</paper-cell>
                      <paper-cell class="permissions-column flex"><p class="permissions">Read</p></paper-cell>
                      <paper-cell class="permissions-column flex"><p class="permissions">Write</p></paper-cell>
                      <paper-cell class="permissions-column flex"><p class="permissions">Admin</p></paper-cell>
                    </paper-row>
                    <template is="dom-repeat" items="{{item.user}}" as="users">
                      <paper-row class="indent">
                        <paper-cell class="users-column users flex" textToCopy$="[[users.email]]" on-click="copyText"
                          >{{users.email}}</paper-cell
                        >
                        <paper-cell class="active-column flex">{{users.last_active}}</paper-cell>
                        <paper-cell class="permissions-column flex"
                          ><paper-checkbox disabled="" checked="{{users.read_permission}}"></paper-checkbox
                        ></paper-cell>
                        <paper-cell class="permissions-column flex"
                          ><paper-checkbox disabled="" checked="{{users.write_permission}}"></paper-checkbox
                        ></paper-cell>
                        <paper-cell class="permissions-column flex"
                          ><paper-checkbox disabled="" checked="{{users.admin}}"></paper-checkbox
                        ></paper-cell>
                      </paper-row>
                    </template>
                  </paper-table>
                </div>
              </paper-table>
            </paper-row>
          </template>
          <paper-row>
            <paper-cell>
              <katapult-button _animate="true" id="export-button" color="#003E51" on-click="openExport">
                <span id="export">Export Company Data</span>
              </katapult-button>
            </paper-cell>
          </paper-row>
        </paper-table>
      </div>

      <!-- Exports Dialogue Box -->
      <katapult-dialog id="exportScreen" color="#003E51" draggable="true" width="600" height="925" closeButton closeOnEscape>
        <div slot="title">Export</div>

        <!-- Table for All Companies -->
        <paper-table class="company-export-table">
          <paper-row>
            <paper-cell>
              <span class="export-instructions">Select Companies to Export:</span>
            </paper-cell>
            <paper-cell id="check-all">
              <katapult-button color="#007299" on-click="checkAll">
                <span id="check-all-button">Check All</span>
              </katapult-button>
            </paper-cell>
          </paper-row>
          <template is="dom-repeat" items="{{allData}}" as="company" index-as="index">
            <paper-row class="company-export-row">
              <paper-cell class="checkbox-cell">
                <paper-checkbox id="[[index]]" checked="{{company.checked}}"></paper-checkbox>
              </paper-cell>
              <paper-cell>
                <span>[[company.name]]</span>
              </paper-cell>
            </paper-row>
          </template>
          <paper-row>
            <paper-cell>
              <katapult-button id="final-export" color="#003E51" on-click="export">
                <span>Finalize Export</span>
              </katapult-button>
            </paper-cell>
          </paper-row>
        </paper-table>
      </katapult-dialog>
    `;
  }

  ready() {
    super.ready();
    // Initialize properties to now
    this.widgetDataUpdate();
  }

  fixWidth(worksheet, headers) {
    // Get the header column lenths and set as the width
    let colLengths = [];
    headers.forEach((attribute) => {
      colLengths.push(attribute.length);
    });
    let index = 0;
    // Go through each row
    for (const d of worksheet) {
      // Go through each cell
      Object.values(d).forEach((element, dIndex) => {
        const length = element.toString().length;
        //This checks if not first row
        if (index > 0) {
          if (colLengths[dIndex] < length) {
            // Update the width if content is wider than header
            colLengths[dIndex + 6] = length;
          }
        } // This is first row - everything after needs a column offset because of company data being to the left
        else {
          if (colLengths[dIndex] < length) {
            // Update the width if content is wider than header
            colLengths[dIndex] = length;
          }
        }
      });
      index++;
    }
    return colLengths;
  }

  openExcelExport(companiesToExport) {
    // Create workbook
    const workbook = XLSX.utils.book_new();

    // Get & format data to export
    let sheet = [];
    let companyUsers = [];
    this.allData.forEach((company) => {
      // Check which companies to export
      if (companiesToExport.includes(company.name) || companiesToExport.includes('Export All')) {
        companyUsers = [];
        company.user.forEach((user, uIndex) => {
          // Check if first user. If yes, add company data to the beginning of the normal row
          if (uIndex === 0) {
            companyUsers.push({
              name: company.name,
              creation_date: company.creation_date,
              days_left: company.days_left,
              used_write: company.used_write_license,
              subscription: company.subscription,
              empty: '',
              last_active: user.last_active,
              email: user.email,
              read_permission: user.read_permission,
              write_permission: user.write_permission,
              admin: user.admin
            });
          } else {
            companyUsers.push(user);
          }
        });
        sheet.push(companyUsers);
      }
    });

    // Add new sheets per company, format column widths
    sheet.forEach((company) => {
      // Create Sheet
      const worksheet = XLSX.utils.json_to_sheet(company);
      const headers = ['Name', 'Creation Date', 'Days Left', 'Used', 'Available', '', 'Last Active', 'Email', 'Read', 'Write', 'Admin'];
      XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: 'A1' });

      // Set Column Widths
      const widths = this.fixWidth(company, headers);
      worksheet['!cols'] = [
        { wch: widths[0] },
        { wch: widths[1] },
        { wch: widths[2] },
        { wch: widths[3] },
        { wch: widths[4] },
        { wch: 10 },
        { wch: widths[6] },
        { wch: widths[7] },
        { wch: widths[8] },
        { wch: widths[9] },
        { wch: widths[10] }
      ];

      // Add Sheet
      XLSX.utils.book_append_sheet(workbook, worksheet, company[0].name);
    });
    XLSX.writeFile(workbook, 'Companies.xlsx', { compression: true });
  }

  export() {
    let companiesToExport = [];
    let allFlag = true;
    this.allData.forEach((company) => {
      if (company.checked === true) {
        companiesToExport.push(company.name);
      } else if (company.checked === false) {
        allFlag = false;
      }
    });
    //Check if exporting all companies, changes how handled in the export function
    if (allFlag === true) {
      companiesToExport = ['Export All'];
    }
    this.openExcelExport(companiesToExport);
  }

  openExport() {
    this.shadowRoot.querySelector('#exportScreen').open();
  }

  checkAll() {
    const buttonText = this.shadowRoot.getElementById('check-all-button');
    //Swap value
    this.allData.forEach((company, index) => {
      if (buttonText.innerText === 'Check All') {
        this.set(`allData.${index}.checked`, true);
      } else {
        this.set(`allData.${index}.checked`, false);
      }
    });
    //Swap Text
    buttonText.innerText = buttonText.innerText === 'Check All' ? 'Uncheck All' : 'Check All';
  }

  //Code to expand and contract drop downs
  expandContent(e) {
    const self = e.currentTarget;

    if (!self.nextElementSibling.style.display || self.nextElementSibling.style.display == 'none') {
      self.nextElementSibling.style.display = 'block';
      self.style.borderBottomRightRadius = '0';
      self.style.borderBottomLeftRadius = '0';
    } else {
      self.nextElementSibling.style.display = 'none';
      self.style.borderBottomRightRadius = '40px';
      self.style.borderBottomLeftRadius = '40px';
    }
  }

  async copyText(e) {
    // Get the text to copy from the current target
    const textToCopy = e.currentTarget.getAttribute('textToCopy');
    const self = e.currentTarget;

    // Special case for copying the user's email
    if (textToCopy == 'email') textToCopy = this.users[this.selectedUserId]?.email || '';

    // If there's a problem copying the text, notify the user
    if (!textToCopy) this.toast('Could not copy text to the clipboard');

    // Write the text to the user's clipboard
    await navigator.clipboard.writeText(textToCopy);

    // Change the styles of the clicked element to reflect it being clicked
    self.style.color = '#404040';

    // Notify the user once the text has been copied
    const toast = this.shadowRoot.getElementById('toast');
    toast.text = 'Copied to clipboard!';
    toast.open();
  }

  // Widget Data Update
  async widgetDataUpdate() {
    // Set temporary push arrays
    var [pageData, holderData, companyList] = [[], [], []];

    // Retrieve company name data
    this.companyData = await FirebaseWorker.ref('photoheight/company_space')
      .once('value')
      .then((s) => s.val());
    this.companyData = Object.values(this.companyData);

    // Remove model companies and push name, creation date, and days left
    this.companyData.forEach((company) => {
      if (company.name != undefined && company.subscription.count != undefined) {
        //Convert and format date
        let companyDate = new Date(company.trainingTimer?.timestamp).toDateString();
        if (companyDate == 'Invalid Date') {
          companyDate = 'N/A';
        }
        //Get days left, format undefined
        let daysLeft = '';
        daysLeft = company.trainingTimer === undefined ? 'N/A' : company.trainingTimer.daysActive;
        companyList.push(snakeCase(company.name));
        holderData.push({ name: company.name, subscription: company.subscription.count, days_left: daysLeft, creation_date: companyDate });
      }
    });

    // Retrieve user data
    const lastActiveCompanies = await FirebaseWorker.ref('users')
      .once('value')
      .then((s) => s.val());

    // Create list of the companies in company_space
    let companySpaceList = [];
    Object.keys(lastActiveCompanies).forEach((company) => {
      companyList.forEach((companyName) => {
        if (companyName === company.toLowerCase()) {
          companySpaceList.push(company);
        }
      });
    });

    // Create list of the companies in users
    let usersDatabaseList = [];
    holderData.forEach((company) => {
      usersDatabaseList.push(snakeCase(company.name));
    });

    var [index, companySpaceData, unfilteredCompanySpaceList] = [0, [], Object.keys(lastActiveCompanies)];
    // Get data from companies in the users database
    Object.values(lastActiveCompanies).forEach((active) => {
      // Initialize/Reset each holder variable to push to JSON
      var [users, userHolder, writeTally, name] = [false, [], 0, unfilteredCompanySpaceList[index]];
      //Only grab data for the companies in the filtered list
      if (companySpaceList.includes(unfilteredCompanySpaceList[index])) {
        Object.values(active).forEach((uid) => {
          if (uid.email != undefined) {
            users = true;
            //Convert and format date
            let date = new Date(uid.last_active).toDateString();
            if (date == 'Invalid Date') {
              date = 'N/A';
            }
            //Tally write permissions
            if (uid.write_permission == true) {
              writeTally++;
            }
            //Push values to holder array
            userHolder.push({
              last_active: date,
              email: uid.email,
              read_permission: uid.read_permission,
              write_permission: uid.write_permission,
              admin: uid.roles.photoheight.company_admin
            });
          }
        });
        //Set data if no users with write permission (empty)
        if (!users) {
          userHolder = [];
          userHolder.push({ last_active: 'N/A', email: 'No Users', read_permission: false, write_permission: false, admin: false });
        }
        companySpaceData.push({ name: capitalCase(name), subscription: 0, used_write_license: writeTally, user: userHolder });
      }
      index++;
    });

    let found = false;
    //Combine data from the separate databases
    holderData.forEach((company) => {
      found = false;
      companySpaceData.forEach((reference) => {
        if (company.name.toUpperCase() === reference.name.toUpperCase()) {
          pageData.push({
            name: company.name,
            subscription: company.subscription,
            days_left: company.days_left,
            creation_date: company.creation_date,
            used_write_license: reference.used_write_license,
            checked: false,
            user: reference.user
          });
          found = true;
        }
      });
      if (found === false) {
        //Flag for when it's a datapoint in holderData but not companySpaceData, fill in data for no users
        pageData.push({
          name: company.name,
          subscription: company.subscription,
          days_left: company.days_left,
          creation_date: company.creation_date,
          used_write_license: 0,
          checked: false,
          user: [{ last_active: 'N/A', email: 'No Users', read_permission: false, write_permission: false, admin: false }]
        });
      }
    });
    this.allData = pageData;
  }
}
window.customElements.define('katapult-company-widget', CompanyWidget);
